import React from "react";
import placeholderImage from "../../../images/placeholder.png";
import {
  UserCircleIcon,
  EnvelopeIcon,
  PhoneIcon,
  BriefcaseIcon,
  IdentificationIcon,
  CalendarIcon,
  MapPinIcon,
  BanknotesIcon,
} from "@heroicons/react/24/solid";

function EmployeeView({ currentRecord }) {
  currentRecord = {
    ...currentRecord,
    church_name: currentRecord?.church_id?.church_name,
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  const recordDetails = [
    {
      key: "name",
      icon: <UserCircleIcon className="w-5 h-5 text-gray-500" />,
      label: "Name",
    },
    {
      key: "email",
      icon: <EnvelopeIcon className="w-5 h-5 text-gray-500" />,
      label: "Email",
    },
    {
      key: "role",
      icon: <BriefcaseIcon className="w-5 h-5 text-gray-500" />,
      label: "Role",
    },
    {
      key: "status",
      icon: <IdentificationIcon className="w-5 h-5 text-gray-500" />,
      label: "Status",
    },
    {
      key: "mobile",
      icon: <PhoneIcon className="w-5 h-5 text-gray-500" />,
      label: "Mobile",
    },
    {
      key: "designation",
      icon: <BriefcaseIcon className="w-5 h-5 text-gray-500" />,
      label: "Designation",
    },
    {
      key: "gender",
      icon: <UserCircleIcon className="w-5 h-5 text-gray-500" />,
      label: "Gender",
    },
    {
      key: "date_of_birth",
      icon: <CalendarIcon className="w-5 h-5 text-gray-500" />,
      label: "Date of Birth",
    },
    {
      key: "address",
      icon: <MapPinIcon className="w-5 h-5 text-gray-500" />,
      label: "Address",
    },
    {
      key: "bank_name",
      icon: <BanknotesIcon className="w-5 h-5 text-gray-500" />,
      label: "Bank Name",
    },
    {
      key: "branch_name",
      icon: <BanknotesIcon className="w-5 h-5 text-gray-500" />,
      label: "Branch Name",
    },
    {
      key: "account_number",
      icon: <BanknotesIcon className="w-5 h-5 text-gray-500" />,
      label: "Account Number",
    },
    {
      key: "ifsc_code",
      icon: <BanknotesIcon className="w-5 h-5 text-gray-500" />,
      label: "Routing Number",
    },
  ];

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <div className="flex flex-col items-center mb-6">
        {currentRecord?.image ? (
          <img
            crossOrigin="anonymous"
            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/employee/${currentRecord?.image}`}
            alt="Employee"
            className="object-cover w-32 h-32 mb-4 rounded-full"
          />
        ) : (
          <img
            src={placeholderImage}
            alt="Placeholder"
            className="object-cover w-32 h-32 mb-4 rounded-full"
          />
        )}
        <h2 className="text-2xl font-semibold text-gray-800">
          {currentRecord.name}
        </h2>
        <p className="text-gray-600">{currentRecord.designation}</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {recordDetails.map((detail) => (
          <div
            key={detail.key}
            className="flex items-center p-3 rounded-md bg-gray-50"
          >
            {detail.icon}
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-500">
                {detail.label}
              </p>
              <p className="text-sm text-gray-900">
                {detail.key === "date_of_birth"
                  ? formatDate(currentRecord[detail.key])
                  : currentRecord[detail.key] || "N/A"}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EmployeeView;
